import type { ExpressionPhrasing, ExpressionShape } from "../en/expressionPhrases.ts";

/**
 * French phrase bank for Writing Expressions (ADR 0123 §3). Same shapes and
 * placeholders as the English file. French is the longest of the three, so it
 * is the language `npm run measure` is most likely to fail first.
 *
 * These phrasings follow textbook usage ("augmenté de", "diminué de", "le
 * double de", "le produit de ... par") and have not been read by a
 * native-speaking teacher.
 */
export const expressionPhrases: Record<ExpressionShape, ExpressionPhrasing[]> = {
    S1: [
        { text: "la somme d'un nombre\u00A0{v} et de\u00A0{b}" },
        { text: "{b} de plus qu'un nombre\u00A0{v}" },
        { text: "un nombre\u00A0{v} augmenté de\u00A0{b}" },
    ],
    S2: [
        { text: "{b} de moins qu'un nombre\u00A0{v}" },
        { text: "un nombre\u00A0{v} diminué de\u00A0{b}" },
        { text: "la différence entre un nombre\u00A0{v} et\u00A0{b}" },
    ],
    S3: [
        { text: "{b} diminué d'un nombre\u00A0{v}" },
        { text: "un nombre\u00A0{v} soustrait de\u00A0{b}" },
        { text: "la différence entre\u00A0{b} et un nombre\u00A0{v}" },
    ],
    S4: [
        { text: "le produit de\u00A0{a} par un nombre\u00A0{v}" },
        { text: "{a} fois un nombre\u00A0{v}" },
        { text: "le double d'un nombre\u00A0{v}", twice: true },
    ],
    S5: [
        { text: "le quotient d'un nombre\u00A0{v} par\u00A0{a}" },
        { text: "un nombre\u00A0{v} divisé par\u00A0{a}" },
    ],
    S6: [
        { text: "le quotient de\u00A0{b} par un nombre\u00A0{v}" },
        { text: "{b} divisé par un nombre\u00A0{v}" },
    ],
    T1: [
        { text: "{b} de plus que le produit de\u00A0{a} par un nombre\u00A0{v}" },
        { text: "le produit de\u00A0{a} par un nombre\u00A0{v}, augmenté de\u00A0{b}" },
        { text: "{b} de plus que le double d'un nombre\u00A0{v}", twice: true },
    ],
    T2: [
        { text: "{b} de moins que le produit de\u00A0{a} par un nombre\u00A0{v}" },
        { text: "le produit de\u00A0{a} par un nombre\u00A0{v}, diminué de\u00A0{b}" },
        { text: "{b} de moins que le double d'un nombre\u00A0{v}", twice: true },
    ],
    T3: [
        { text: "{b} diminué du produit de\u00A0{a} par un nombre\u00A0{v}" },
        { text: "la différence entre\u00A0{b} et le produit de\u00A0{a} par un nombre\u00A0{v}" },
        { text: "{b} diminué du double d'un nombre\u00A0{v}", twice: true },
    ],
    T4: [
        { text: "{a} fois la somme d'un nombre\u00A0{v} et de\u00A0{b}" },
        { text: "le produit de\u00A0{a} par la somme d'un nombre\u00A0{v} et de\u00A0{b}" },
        { text: "le double de la somme d'un nombre\u00A0{v} et de\u00A0{b}", twice: true },
    ],
    T5: [
        { text: "{a} fois la différence entre un nombre\u00A0{v} et\u00A0{b}" },
        { text: "le produit de\u00A0{a} par la différence entre un nombre\u00A0{v} et\u00A0{b}" },
        { text: "le double de la différence entre un nombre\u00A0{v} et\u00A0{b}", twice: true },
    ],
    T6: [
        { text: "{b} de plus que le quotient d'un nombre\u00A0{v} par\u00A0{a}" },
        { text: "le quotient d'un nombre\u00A0{v} par\u00A0{a}, augmenté de\u00A0{b}" },
    ],
};
